.control {
  position: relative;
  display: flex;
  align-items: center;
  min-width: 0;
}

.input {
  width: 100%;
  min-height: var(--control-height-md);
  padding: 9px 11px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-input);
  background-color: var(--color-surface);
  color: var(--color-text);
  font-size: var(--text-sm);
  transition:
    border-color var(--duration-fast) var(--ease-standard),
    box-shadow var(--duration-fast) var(--ease-standard);
}

/* Anything below 16px makes iOS zoom the viewport on focus. */
@media (pointer: coarse) {
  .input {
    font-size: 1rem;
  }
}

.input::placeholder {
  color: var(--color-text-faint);
}

.input:hover:not(:disabled, :focus) {
  border-color: var(--color-border-strong);
}

.input:focus {
  outline: none;
  border-color: var(--color-brand-soft);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--color-brand-soft) 16%, transparent);
}

.input:disabled {
  background-color: var(--color-surface-sunken);
  color: var(--color-text-faint);
  cursor: not-allowed;
}

.invalid,
.invalid:hover,
.invalid:focus {
  border-color: var(--color-danger);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--color-danger) 16%, transparent);
}

/* Chrome paints autofilled fields pale yellow, which would tear a hole in the
   glass panel on the sign-in screen. */
.input:-webkit-autofill,
.input:-webkit-autofill:hover,
.input:-webkit-autofill:focus {
  -webkit-text-fill-color: var(--color-text);
  caret-color: var(--color-text);
  box-shadow: 0 0 0 1000px var(--color-surface) inset;
  transition: background-color 100000s ease 0s;
}

.lg .input {
  min-height: var(--control-height-lg);
  padding: 12px 14px;
  /* The sign-in screens keep the larger type; dense forms stay compact. */
  font-size: var(--text-md);
}

.hasLeading .input {
  padding-left: 40px;
}

.hasTrailing .input {
  padding-right: 46px;
}

.leading {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  color: var(--color-text-faint);
  pointer-events: none;
}

.leading svg {
  width: 18px;
  height: 18px;
}

.trailing {
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
}

.lg .trailing {
  right: 5px;
}
